/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AuditActivity = core.serialization.enum_([
    "agent:created",
    "agent:updated",
    "agent:deleted",
    "space:created",
    "space:updated",
    "space:deleted",
    "space:archived",
    "space:unarchived",
    "space:expired",
    "space:guestAdded",
    "space:guestRemoved",
    "document:created",
    "document:updated",
    "document:deleted",
    "workbook:created",
    "workbook:updated",
    "workbook:deleted",
    "workbook:expired",
    "sheet:created",
    "sheet:updated",
    "sheet:deleted",
    "snapshot:created",
    "file:created",
    "file:deleted",
    "file:expired",
    "job:created",
    "job:deleted",
    "job:completed",
    "job:ready",
    "job:scheduled",
    "job:outcome-acknowledged",
    "job:parts-completed",
    "job:failed",
    "program:created",
    "program:updated",
    "commit:created",
    "commit:updated",
    "commit:completed",
    "layer:created",
    "secret:created",
    "secret:updated",
    "secret:deleted",
]);
